import { Card, Col, Form, Button, Row } from "react-bootstrap";
import Table from "../../Components/UI/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../utils/types";
import { useEffect, useState } from "react";
import { GetEventsAction } from "../../Redux/Actions/EventsLoggerActions";
import "./style.css";
import { useFormik } from "formik";
import {
  convertLocalToUtc,
  convertLocalToUtcWithSeconds,
  convertUtcToLocal,
  convertUtcToLocalWithSeconds,
} from "../../utils/functions";
import { ToastAction } from "../../Redux/Actions/ToastAction";
import CsvDownloader from "react-csv-downloader";
import { adminColumns, commonColumns } from "./eventsLoggerConstant";
import FeatherIcon from "feather-icons-react";
// import {sha256} from 'crypto-hash';
// import {crypto} from 'crypto';
// const crypto = require('crypto');
import { sha1 } from "js-sha1";
import HashModal, { HashButton } from "../Admin/HashModal";
import Select from "react-select";
import moment from "moment";

const EventsLogger = () => {
  const dispatch = useDispatch();
  const AuthState = useSelector(
    (state: IReduxState) => state.Auth
  );
  const EventsLoggerState = useSelector(
    (state: IReduxState) => state.EventsLogger
  );

  // const [eventType, setEventType] = useState("All Events")
  const [filteredList, setFilteredList] = useState(EventsLoggerState?.events);
  const [upFiltersList, setUpFiltersList] = useState(EventsLoggerState?.events);
  const [csvData, setCsvData] = useState(EventsLoggerState?.events);
  const [selectedType, setSelectedType] = useState("All Events");
  const [showHashModal, setShowHashModal] = useState(false);
  const [userOptionSelected, setUserOptionSelected] = useState<any>({ label: "All Linked Users", value: "" });
  const [dateOptionSelected, setDateOptionsSelected] = useState('13')
  const [searchInput, setSearchInput] = useState('')
  const handleCloseModal = () => setShowHashModal(false);
  const [showAllChecked, setShowAllChecked] = useState(false);
  const [cfscId_list, setCfscIdList] = useState<any[]>([]);
  function getSha1(val: any) {
    // var shasum = sha1.create(sha256, val)
    // shasum.update(val);
    // return shasum.digest('hex');
    sha1(val);
    var hash = sha1.create();
    hash.update(val);
    return hash.hex();
  }

  let allUsersArray: any = [];
  if (AuthState?.subUsers) {
    allUsersArray =[
    { label: "All Linked Users", value: "" },
    ...AuthState.subUsers.map((obj: any) => ({
      ...obj,
      value: obj.cLogger_id,
      label: `${obj.name} | ${obj.cLogger_id}`,
    })),
  ];
  }

  let matchingUsers = AuthState.subUsers.filter((user: any ) => AuthState.cjscIds.includes(user._id));

  if (matchingUsers.length >= 1) {
    matchingUsers = [
      { label: "All Linked Users", value: "" },
      ...matchingUsers.map((obj:any) => ({
        ...obj,
        value: obj.cLogger_id,
        label: `${obj.name} | ${obj.cLogger_id}`,
      })),
    ];
  }

  const filterEventsBySearch = (searchInput: string, list: any) => {
    if (!searchInput || searchInput === '') {
      return list;
    }
    const searchSha1 = getSha1(searchInput);

    const isDateFormat = /\d{2}\/\d{2}\/\d{4}/.test(searchInput);
    const isTimeFormat = /\d{2}:\d{2}:\d{2}(:\d{3})/.test(searchInput);

    if (isDateFormat) {
      searchInput = convertLocalToUtc(searchInput,'DD/MM/YYYY', 'YYYY-MM-DD')
  } else if (isTimeFormat) {
      searchInput = convertLocalToUtcWithSeconds(searchInput,'HH:mm:ss:SSS', 'HH:mm:ss.SSS')
  }

    const filtered = list.filter((event: any) => {
      return Object.values(event).some(
        (value) =>
          String(value).toLowerCase().includes(searchInput.toLowerCase()) ||
          String(value).toLowerCase().includes(searchSha1.toLowerCase())
      );
    });
    return filtered
  };

  const filterEventsByDate = (daysAgo:any, input:any) => {
    const days = Number(daysAgo);
    const today = moment();
    const startDate = today.clone().subtract(days, 'days').startOf('day');
    const endDate = today.endOf('day');

    return input.filter((event:any) => {
        const eventDate = moment(event.timestamp);
        return eventDate.isBetween(startDate, endDate, null, '[]');
    });
}

  const filterEventsByCreator = (creator: any, input: any) => {
    if (!creator || creator.value === '') {
      return input;
    }
    return input.filter(
      (item: any) => item.user === creator.cLogger_id
    );
  };

  const filterEventsByType = (id: any, input:any) => {
    if (id === "All Events") {
      return input;
    }
    if (id === "Mobile") {
      const lll = input.filter(
        (item: any) => item.type.toLowerCase() === "mobile"
      );
      return lll;
    }
    if (id === "CallBack") {
      const lll = input.filter(
        (item: any) => item.type.toLowerCase() === "callback"
      );
      return lll;
    }
    if (id === "Deanon") {
      const lll = input.filter(
        (item: any) => item.type.toLowerCase() === "deanon"
      );
      return lll;
    }
    if (id === "Errors") {
      const lll = input.filter((item: any) => item.remark);
      return lll;
    }
  };

  const runFilter = (type:any,creator:any, daysAgo:any, searchInput:any) => {
    let input = EventsLoggerState.events
    // filter by date range
    let filterByDate = filterEventsByDate(daysAgo,input)
    let filterByUser = filterEventsByCreator(creator,filterByDate)
    let filterByType = filterEventsByType(type,filterByUser)
    let filterBySearch = filterEventsBySearch(searchInput,filterByType)
    setFilteredList(filterBySearch)
    // setFilteredList(filterByType)
  }

  function makeCSV(mylist: any) {
    if (AuthState.role.includes("admin")) {
      const ccc = mylist.map((item: any) => {
        const fixedItem: any = {};
        for (const prop in item) {
          fixedItem[prop] = item[prop]
            ? item[prop].includes(",")
              ? `"${item[prop]}"`
              : item[prop]
            : "";
        }
        return {
          ...fixedItem,
          Date: convertUtcToLocal(fixedItem.timestamp, "DD/MM/YYYY"),
          Time: convertUtcToLocalWithSeconds(
            fixedItem.timestamp,
            "HH:mm:ss:SSS"
          ),
          "Event Type": fixedItem.type,
          "Campaign Name": fixedItem.camp_name,
          "Campaign Status": fixedItem.remark,
          USER: fixedItem.user,
          USER_ID: fixedItem.user_id,
          BUNDLE: fixedItem.bundle,
          DOMAIN: fixedItem.domain,
          USER_SHA1: fixedItem.user_sha1,
          "Auction ID":fixedItem.ai,
          "Bid Time":fixedItem.bt,
          CAMP_ID: fixedItem.camp_id,
          IP: fixedItem.ip,
          // URL: fixedItem.url,
          // (adminState.role.includes("admin"))?"":"",
          EXC: fixedItem.exc,

          // 'User IP': fixedItem.userIP,
          "Concat IP": fixedItem.concat,
          Referrer: fixedItem.referrer,
          "Client Type": fixedItem.clientType,
          "Client Name": fixedItem.clientName,
          "Device Type": fixedItem.deviceType,
          "Device Brand": fixedItem.deviceBrand,
          "Device Model": fixedItem.deviceModel,
          "OS Name": fixedItem.osName,
          "OS Version": fixedItem.osVersion,
          "User Agent": fixedItem.userAgent,
          "CB User IP": fixedItem.userIP,
          "Browser" : fixedItem.browser
        };
      });
      setCsvData(ccc);
    } else {
      const ccc = mylist.map((item: any) => {
        const fixedItem: any = {};
        for (const prop in item) {
          fixedItem[prop] = item[prop]
            ? item[prop].includes(",")
              ? `"${item[prop]}"`
              : item[prop]
            : "";
        }
        return {
          ...fixedItem,
          Date: convertUtcToLocal(fixedItem.timestamp, "DD/MM/YYYY"),
          Time: convertUtcToLocalWithSeconds(
            fixedItem.timestamp,
            "HH:mm:ss:SSS"
          ),
          "Event Type": fixedItem.type,
          "Campaign Status": fixedItem.remark,
          USER: fixedItem.user,
          USER_ID: fixedItem.user_id,
          BUNDLE: fixedItem.bundle,
          DOMAIN: fixedItem.domain,
          USER_SHA1: fixedItem.user_sha1,
          CAMP_ID: fixedItem.camp_id,
          IP: fixedItem.ip,
          // URL: fixedItem.url,
          // (adminState.role.includes("admin"))?"":"",
          // 'EXC':fixedItem.exc,

          // 'User IP': fixedItem.userIP,
          "Concat IP": fixedItem.concat,
          Referrer: fixedItem.referrer,
          "Client Type": fixedItem.clientType,
          "Client Name": fixedItem.clientName,
          "Device Type": fixedItem.deviceType,
          "Device Brand": fixedItem.deviceBrand,
          "Device Model": fixedItem.deviceModel,
          "OS Name": fixedItem.osName,
          "OS Version": fixedItem.osVersion,
          "User Agent": fixedItem.userAgent,
          "CB User IP": fixedItem.userIP,
          "Browser": fixedItem.browser
        };
      });
      setCsvData(ccc);
    }
  }

  const formik: any = useFormik({
    initialValues: {
      startDate: "",
      endDate: "",
      search: "",
    },
    onSubmit: (value, { resetForm }) => {
        runFilter(selectedType,userOptionSelected,dateOptionSelected,searchInput)
      // }
    },
  });

  const refresh = () => {
    runFilter(selectedType,userOptionSelected,dateOptionSelected,searchInput)
  };

  useEffect(() => {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let endDate = new Date();
    let startDate = new Date(today.setDate(today.getDate() - 13));
    dispatch(GetEventsAction(startDate, endDate,showAllChecked));
  }, [dispatch]);

  useEffect(() => {
    runFilter(selectedType,userOptionSelected,dateOptionSelected,searchInput);
    // makeCSV(EventsLoggerState.events);
  }, [EventsLoggerState]);

  useEffect(() => {
    setCfscIdList(matchingUsers)
  }, [AuthState]);

  const handleChangeUser = (selected: any) => {
    setUserOptionSelected(selected);
  };

  useEffect(() => {
    makeCSV(filteredList)
  },[filteredList])

  const sizePerPageList = [
    {
      text: "10",
      value: 10,
    },
    {
      text: "25",
      value: 25,
    },
    {
      text: "50",
      value: 50,
    },
  ];
  let columns = [];
  let typeOptions = [];

  if (AuthState.role.includes("admin")) {
    columns = adminColumns;
  } else {
    columns = commonColumns;

    if (AuthState.concat) {
      columns = [
        ...columns,
        {
          Header: "Concat IP",
          accessor: "concat",
          sort: false,
        },
      ];
    }
    //   columns = [
    //     ...columns,
    //   // {
    //   //   Header: "Campaign Status",
    //   //   accessor: "remark",
    //   //   sort: false,
    //   // },
    // ];
  }
  let newColumns = columns.map((column: any) => ({
    id: column.Header,
    displayName: column.Header,
  }));
  // ["All Events","CallBack", "Mobile"]
  typeOptions = [
    { value: "All Events", label: "All Events" },
    { value: "CallBack", label: "CallBack" },
    { value: "Mobile", label: "Mobile" },
    // { value: "Errors", label: "Errors" },
  ];

  if (AuthState.panda === true) {
    typeOptions = [...typeOptions, { value: "Deanon", label: "DeAnon" }];
  }

  useEffect (() => {
    runFilter(selectedType,userOptionSelected,dateOptionSelected,searchInput)
  },[selectedType,userOptionSelected,dateOptionSelected])

  const handleShowAllUsers = (event: { target: { checked: boolean } }) => {
    setCfscIdList([]);
    const isChecked = event.target.checked;
    setShowAllChecked(isChecked)
  
    if (isChecked) {
      setCfscIdList(allUsersArray)
    } else {
      setCfscIdList(matchingUsers)
    }
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let endDate = new Date();
    let startDate = new Date(today.setDate(today.getDate() - Number(dateOptionSelected)));
    dispatch(GetEventsAction(startDate,endDate,isChecked))
  };

  return (
    <>
      {showHashModal && (
        <HashModal showHashModal={showHashModal} onClose={handleCloseModal} />
      )}
      <Row className="d-flex justify-content-center mt-3">
        <Row>
          <h3 className="module_title" style={{ marginBottom: "0px" }}>
            Events Logger
            <p>
              For internal testing of test links as well as callback on
              activated campaigns
            </p>
          </h3>
        </Row>
      </Row>
      <Card>
        <Card.Header
          style={{
            backgroundColor: "#fff",
            borderBottom: "0",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <Row className="align-items-center mb-2">
  {/* Label and Select */}
  <Col className="d-flex align-items-center">
    <Form.Label htmlFor="dateRangeSelect" className="mb-0 me-4" style={{whiteSpace:"nowrap"}}>
      Date Range:
    </Form.Label>
    <Form.Select
      id="dateRangeSelect"
      className="fsz-875rem"
      style={{ width: "16em" }}
      onChange={(e: any) => setDateOptionsSelected(e.target.value)}
      defaultValue={"13"}
    >
      <option value="0">Today</option>
      <option value="1">Yesterday</option>
      <option value="2">Last 3 Days</option>
      <option value="6">Last 7 Days</option>
      <option value="13">Last 14 Days</option>
    </Form.Select>
  </Col>

  {/* Buttons on the right */}
  <Col className="d-flex justify-content-end">
    {AuthState.show_hash && (
      <HashButton
        onClick={() => setShowHashModal(true)}
        className="me-2 orange-btn"
      />
    )}
    <CsvDownloader
      datas={csvData}
      columns={newColumns}
      text="Export to CSV"
      filename={`events_${new Date().toLocaleString()}`}
      extension=".csv"
      className="btn btn-primary ExportBtn no-margin"
    />
  </Col>
</Row>

<Row className="align-items-center">
  {/* Label and Select */}
  <Col className="d-flex justify-content-start me-2 gap-3">
          {cfscId_list.length > 0 && (
      <>
      <div className="d-flex align-items-center">
        <Form.Label htmlFor="createUserSelect" className="mb-0 me-2">
            Created By User
          </Form.Label>
          <Select
            className="fsz-875rem"
            onChange={handleChangeUser}
            name="subUsers"
            options={cfscId_list}
            hideSelectedOptions={false}
            defaultValue={{ label: "All Linked Users", value: "" }}
            value={userOptionSelected}
            // maxMenuHeight={100}
            styles={{
              control: (provided) => ({
                ...provided,
                minWidth: "16em"
              }),
            }}
          />
        </div>
      </>)}
      <div className="d-flex align-items-center">
          <Form.Label htmlFor="eventSelect" className="mb-0 me-2">
        Event Type:
      </Form.Label>
      <Form.Select
        name="type"
        id="eType"
        className="fsz-875rem"
        onChange={(e) => {
          setSelectedType(e.target.value);
        }}
        value={selectedType}
        style={{ width: "16em" }}
      >
        {typeOptions.map((item: any) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </Form.Select>
      </div>
      </Col>
      <Col className="d-flex justify-content-end">
    <span
      onClick={refresh}
      style={{
        verticalAlign: "10px",
        color: "#808080",
        cursor: "pointer",
        fontSize: "16px",
        // display: "flex",
        alignItems: "center",
      }}
    >
      <FeatherIcon
      column
      md={1}
        icon="refresh-ccw"
        className="icon-dual icon-l"
        style={{ color: "#808080", cursor: "pointer",}}
      />{" "}
      Refresh Results
    </span>
    </Col>
</Row>
          <Row>
            <Col>
              <hr className="my-2" />
            </Col>
          </Row>
          <Row className="align-items-center mb-2">
  {/* Label and Select */}
  <Col className="d-flex align-items-center">
    <Form.Label htmlFor="dateRangeSelect" className="mb-0 me-4" style={{whiteSpace:"nowrap"}}>
        Search in Results
      </Form.Label>
      <Form.Control
        className="fsz-875rem"
        style={{ width: "16em" }}
        id="search"
        type="text"
        name="search"
        value={formik.values.search}
        onChange={formik.handleChange}
        isInvalid={!!formik.errors?.search}
      />
      <Button
        className="noMargin ms-2"
        onClick={() => {
          setSearchInput(formik.values.search)
          runFilter(selectedType,userOptionSelected,dateOptionSelected,formik.values.search)
        }}
        variant="success"
      >
        Apply
      </Button>
      <Button
        className="noMargin ms-2"
        onClick={() => {
          setSearchInput('')
          formik.setFieldValue('search','')
          runFilter(selectedType,userOptionSelected,dateOptionSelected,'')
        }}
        variant="secondary"
      >
        Clear
      </Button>
    </Col>
    {AuthState.role.includes("admin")&&(
      <Row className="mt-2">
              <Col style={{display:"flex"}}>
              <Form.Check
                  id="showAll"
                  name="showAll"
                  className="fsz-875rem mt-1"
                  onChange={handleShowAllUsers}
                />
                <Form.Label htmlFor="showAll" id="smallerFontSize" className="m-1">
                  Show All Users
                </Form.Label>
              </Col>
      </Row>
)}
</Row>

        </Card.Header>
        <Card.Body>
          <Table
            columns={columns}
            data={filteredList}
            pageSize={10}
            sizePerPageList={sizePerPageList}
            isSortable={false}
            pagination={true}
            isSearchable={false}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default EventsLogger;
